import { StyleSheet } from 'react-native';
import { spacing } from '../../constants/spacing';

export const viewStyles = StyleSheet.create({
  weekContainer: {
    flexDirection: 'row',
    marginBottom: spacing.small,
  },
});
